module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "printIncident",
    attrs: {
      "id": "incidentDialog"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        1
      }
    }
  }, [(_vm.dialogVisible) ? _c('el-dialog', {
    staticClass: "incident_dialog",
    attrs: {
      "show-close": false,
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "title"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('ROUTE') + ' ' + _vm.incident.TourName)
    },
    slot: "title"
  }), _vm._v(" "), _c('el-button', {
    staticClass: "el-dialog__headerbtn",
    attrs: {
      "slot": "title",
      "type": "text"
    },
    on: {
      "click": _vm.deleteIncident
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "el-dialog__close el-icon-close"
  })]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "el-dialog__headerbtn",
    attrs: {
      "slot": "title"
    },
    on: {
      "command": _vm.printIncident
    },
    slot: "title"
  }, [_c('el-button', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "type": "text"
    }
  }, [_c('i', {
    staticClass: "el-dialog__close el-icon-more rotate-90"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" " + _vm._s(_vm.$t('PRINTINCIDENT')))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    ref: "gmap",
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "id": "gmap-incident"
    }
  }), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "student",
    attrs: {
      "gutter": 10
    }
  }, [(_vm.total == 0) ? _c('div', [_vm._v(_vm._s(_vm.$t('NOSTUDENTSINVOLVED')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.incident.students), function(student, index) {
    return (_vm.total != 0) ? _c('el-col', {
      key: index,
      attrs: {
        "span": 24 / _vm.total
      }
    }, [_c('img', {
      staticClass: "img-circle",
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "src": _vm.getAsset(student.ImagePath, 'student')
      }
    }), _c('br'), _vm._v("\n          " + _vm._s(_vm._FullName({
      NameEN: student.FullName_EN,
      NameAR: student.FullName_AR
    })) + "\n        ")]) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8,
      "align": "center"
    }
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" " + _vm._s(_vm.alert ? 'Alert Type' : _vm.$t('INCIDENTTYPE')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block",
      "height": "10px"
    }
  }), _vm._v("  " + _vm._s(_vm.$t(_vm.incident.incident_type)) + "\n          ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "align": "center"
    }
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-bus"
  }), _vm._v(" " + _vm._s(_vm.$t('BUSNUMBER')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block",
      "height": "10px"
    }
  }), _vm._v(" "), _c('el-tag', [_vm._v(_vm._s(_vm.incident.bus.Label))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "align": "center"
    }
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" " + _vm._s(_vm.$t('SUPERVISORMOBILE')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block",
      "height": "10px"
    }
  }), _vm._v("   " + _vm._s(_vm.incident.monitor.MobilePhone) + "\n          ")])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "10px"
    }
  }, [(!_vm.alert) ? _c('b', [_vm._v(_vm._s(_vm.$t('MESSAGEH')) + " ")]) : _vm._e(), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.incident.Text !== null ? _vm.incident.Text : _vm.$t('NOMESSAGE'))
    }
  }, [_vm._v(_vm._s(_vm.$t('MESSAGE')))])]), _vm._v(" "), (_vm.isAllowed('save', 'report/incident') && !_vm.alert) ? _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-popover', {
    attrs: {
      "trigger": "manual",
      "placement": "top",
      "width": "300"
    },
    model: {
      value: (_vm.popperVisible),
      callback: function($$v) {
        _vm.popperVisible = $$v
      },
      expression: "popperVisible"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('RESOLUTION')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "maxlength": 256,
      "rows": 4,
      "placeholder": _vm.$t('WRITEYOURMESSAGE')
    },
    model: {
      value: (_vm.message.Text),
      callback: function($$v) {
        _vm.$set(_vm.message, "Text", $$v)
      },
      expression: "message.Text"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "5px"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.popperVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.message.Text == '',
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.markResolved
    }
  }, [_vm._v(_vm._s(_vm.$t('SAVE')))])], 1), _vm._v(" "), _c('el-button-group', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.incident.statusColor == 0,
      "type": _vm.incident.statusColor == 0 ? 'success' : ''
    },
    on: {
      "click": function($event) {
        _vm.popperVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: [_vm.incident.statusColor != 0 ? 'fa-square-o' : 'fa-check-square']
  }), _vm._v(" " + _vm._s(' ' + _vm.incident.statusColor == 0 ? _vm.$t('RESOLVED') : _vm.$t('MARKRESOLVED')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.incident.statusColor == 0 ? 'warning' : 'primary'
    },
    on: {
      "click": _vm.reportIncident
    }
  }, [_c('i', {
    class: [_vm.incident.statusColor == 0 ? 'fa fa-undo ' : '']
  }), _vm._v(" " + _vm._s(' ' + _vm.incident.statusColor == 0 ? _vm.$t('RE-OPEN') : _vm.$t('REPORTTO')))])], 1)], 1), _vm._v(" "), (_vm.incident.ImagePath) ? _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "icon": "picture"
    },
    on: {
      "click": function($event) {
        _vm.imageVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('VIEWIMAGE')))]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('REPORTINCIDENTTO'),
      "visible": _vm.sendReport,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.sendReport = $event
      }
    }
  }, [_c('span', [_c('el-radio-group', {
    model: {
      value: (_vm.message.Recipient),
      callback: function($$v) {
        _vm.$set(_vm.message, "Recipient", $$v)
      },
      expression: "message.Recipient"
    }
  }, [(_vm.hideParentsOption()) ? _c('el-radio-button', {
    attrs: {
      "label": 6
    }
  }, [_vm._v(_vm._s(_vm.$t('PARENTS')))]) : _vm._e(), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 7
    }
  }, [_vm._v(_vm._s(_vm.$t('POLICE')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 8
    }
  }, [_vm._v(_vm._s(_vm.$t('BUSCOMPANY')))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px 0"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": _vm.$t('WRITEYOURMESSAGE')
    },
    model: {
      value: (_vm.message.Text),
      callback: function($$v) {
        _vm.$set(_vm.message, "Text", $$v)
      },
      expression: "message.Text"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.sendReport = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.message.Text == '' || _vm.message.Recipient == null,
      "type": "primary",
      "loading": _vm.loadingSend
    },
    on: {
      "click": _vm.reportTo
    }
  }, [_vm._v(" " + _vm._s(_vm.loadingSend ? _vm.$t('SENDING') : _vm.$t('SENDMESSAGE')))])], 1)]), _vm._v(" "), (_vm.imageVisible) ? _c('el-dialog', {
    attrs: {
      "size": "tiny",
      "title": _vm.$t('INCIDENTIMAGE'),
      "visible": _vm.imageVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.imageVisible = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.getAsset(_vm.incident.ImagePath, 'incident')
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.imageVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-861190a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/Incident.vue
// module id = 619
// module chunks = 1